import{stringifyScope as e}from"@nohara-dxdev/roles";const t=async(t,n,r)=>{let i=r?{scope:e(r)}:{};await t.delete(`/users/${n}`,{params:i})};export{t as removeUser};
//# sourceMappingURL=remove-user.mjs.map